import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TermsConditionLayer from "../components/TermsConditionLayer";

const TermsConditionPage = () => {
  return (
    <>

        

        {/* Breadcrumb */}
        <Breadcrumb title="Terms & Conditions" icon="solar:document-text-outline" />

        {/* TermsConditionLayer */}
        <TermsConditionLayer />

       

    </>
  );
};

export default TermsConditionPage; 
